import { CanActivateFn, Router, Data } from '@angular/router';
import { inject } from '@angular/core';

import { JwtService } from '@services/jwt.service';
import { GrantService } from '@services/grant.service';

export const authGuard: CanActivateFn = (route, state) => {

    const router = inject(Router);

    //check authentication

    try {

        JwtService.get();

    } catch {

        console.log("No valid auth token");
        return router.parseUrl('/login');

    }

    //check authorization

    const data: Data | undefined = route.routeConfig?.data;
    const endpoint_id: number | undefined = data ? data['endpoint_id'] : undefined;

    try {

        if (!GrantService.get(endpoint_id)) {
            console.log("Grant not found");
            return router.parseUrl('/');
        }

    } catch {

        console.log("Grants not fetched");
        return router.parseUrl('/login');
  
    }

    return true;

};